import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withContext, getMarginBottomClass, gridStyles, eventBus, marginBottomLevels } from '@piggybank/core';
import { Consumer } from '../Field/context.js';
import pick from 'lodash/fp/pick';
import styles from './text-input.css.js';

var getOnChangeHandler = function getOnChangeHandler(fn, maxLength, name) {
  return function (event) {
    var value = maxLength ? event.target.value.slice(0, maxLength) : event.target.value;
    eventBus.dispatch({
      type: 'onChange',
      component: 'TextInput',
      value: value,
      name: name
    });
    fn({
      value: value,
      event: event
    });
  };
};

var TextInput = React.forwardRef(function (_ref, ref) {
  var _cn;

  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'input' : _ref$component,
      fullWidth = _ref.fullWidth,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? false : _ref$invalid,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? 0 : _ref$marginBottom,
      name = _ref.name,
      onChange = _ref.onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? true : _ref$required,
      describers = _ref.describers,
      maxLength = _ref.maxLength,
      rest = _objectWithoutProperties(_ref, ["component", "fullWidth", "invalid", "marginBottom", "name", "onChange", "value", "required", "describers", "maxLength"]);

  return React.createElement(Component, _extends({
    "aria-invalid": invalid,
    "aria-describedby": describers,
    className: cn(styles['TextInput'], getMarginBottomClass(marginBottom), (_cn = {}, _defineProperty(_cn, styles.Invalid, invalid), _defineProperty(_cn, styles.fullWidth, fullWidth), _defineProperty(_cn, gridStyles['size-12'], !fullWidth), _defineProperty(_cn, gridStyles['sizeMedium-7'], !fullWidth), _defineProperty(_cn, gridStyles['sizeLarge-4'], !fullWidth), _cn)),
    id: "".concat(name, "-field"),
    name: name,
    onChange: getOnChangeHandler(onChange, maxLength, name),
    ref: ref,
    type: "text",
    required: required,
    value: value,
    maxLength: maxLength
  }, rest));
});
TextInput.displayName = 'TextInput';
TextInput.propTypes = process.env.NODE_ENV !== "production" ? {
  /** docgen-ignore */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  fullWidth: PropTypes.bool,

  /** docgen-from-context:<Field/> */
  invalid: PropTypes.bool,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),

  /** docgen-from-context:<Field/> */
  name: PropTypes.string.isRequired,

  /** docgen-from-context:<Field/> */
  onBlur: PropTypes.func,

  /**
   * docgen-from-context:<Field/>
   * ---
   * proxied to eventBus
   */
  onChange: PropTypes.func.isRequired,

  /** docgen-from-context:<Field/> */
  value: PropTypes.string,

  /** docgen-from-context:<Field/> */
  required: PropTypes.bool,

  /** docgen-from-context:<Field/> */
  describers: PropTypes.string,
  maxLength: PropTypes.number
} : {};
TextInput.defaultProps = {
  component: 'input',
  fullWidth: false,
  marginBottom: 0
};
var TextInput$1 = withContext(Consumer, pick(['name', 'value', 'onChange', 'onBlur', 'invalid', 'required', 'describers']))(TextInput);
export default TextInput$1;
export { TextInput };